import { render, staticRenderFns } from "./BrandListTable.vue?vue&type=template&id=cd4ca684&scoped=true&"
import script from "./BrandListTable.vue?vue&type=script&lang=js&"
export * from "./BrandListTable.vue?vue&type=script&lang=js&"
import style0 from "./BrandListTable.vue?vue&type=style&index=0&id=cd4ca684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4ca684",
  null
  
)

export default component.exports